import { environment } from '../../../environments/environment';

export const ApiEndpoints = {
  authentication: {
    login: environment.apiUrl + '/provider/authentication/login',
  },

  reports: {
    arrivalTimeReport:
      environment.apiUrl + '/provider/rides/arrival-time-report',
    generateExcel:
      environment.apiUrl + '/provider/rides/arrival-time-report/excel',
    arrivalTimeBlueprintSearch:
      environment.apiUrl + '/provider/rides/arrival-time-report/blueprints',
  },

  drivers: {
    leads: environment.apiUrl + '/provider/partners/leads/get',
    driversAndMonitors: environment.apiUrl + '/provider/partners/get',
    leadsStatistics: environment.apiUrl + '/provider/partners/leads-statistics',
    driversDataIntegrity: environment.apiUrl + '/provider/partners/compliance',
    DataIntegrityStatistics:
      environment.apiUrl + '/provider/partners/leads/chart-statistics',
    archive: environment.apiUrl + '/provider/partners/archive',
    // New API endpoints for edit driver functionality
    getDriverById: environment.apiUrl + '/provider/partners/profile',
    getPartnerStates: environment.apiUrl + '/provider/partners/states',
    getDriverRestrictionsById:
      environment.apiUrl + '/provider/partners/restrictions',
    getPartnerActivityLogs: environment.apiUrl + '/provider/partners',
    serviceAreas: environment.apiUrl + '/provider/organization/service-areas',
    specialists: environment.apiUrl + '/provider/accounts',
    resetPassword:
      environment.apiUrl + '/provider/accounts/set-partner-default-password',
    emergencyContacts: environment.apiUrl + '/provider/Contacts/partners',
    createContact: environment.apiUrl + '/provider/Contacts',
    updateContact: environment.apiUrl + '/provider/Contacts',
    popups: {
      contractors: environment.apiUrl + '/provider/partners',
      dataIntegrity: environment.apiUrl + '/provider/partners/compliance',
    },
    legalIdentification: environment.apiUrl + '/provider/partners',
    availabilityHours: environment.apiUrl + '/provider/partners',
    BackgroundCheck: environment.apiUrl + '/provider/partners',
    getBackgroundCheckById:
      environment.apiUrl + '/provider/partners/background-check',
    createBackgroundCheck:
      environment.apiUrl + '/provider/partners/background-check',
    updateBackgroundCheck:
      environment.apiUrl + '/provider/partners/background-check',

    additionalCheck: environment.apiUrl + '/provider/partners',
    updateAdditionalCheck:
      environment.apiUrl + '/provider/partners/additional-check',
    bankAccount: environment.apiUrl + '/provider/partners',
    vehiclesData: environment.apiUrl + '/provider/partners',
    editVehicleData: environment.apiUrl + '/provider/partners',
    createVehicle: environment.apiUrl + '/provider/partners',
    updateLeadStatus:
      environment.apiUrl + '/provider/partners/update-lead-status',
    createNewAnswers: environment.apiUrl + '/provider/Questioners/answer',
    getQuestionsWithAnswers:
      environment.apiUrl + '/provider/Questioners/with-answers',
    getQuestionsList:
      environment.apiUrl + '/provider/Questioners/questions-list',
    getPartnerPermanentAssignments:
      environment.apiUrl + '/provider/blueprints/partner-permanent-assignments',
    getPartnerTemporaryAssignments:
      environment.apiUrl + '/provider/blueprints/partner-temporary-assignments',
    deleteDriverRestriction:
      environment.apiUrl + '/provider/partners/restrictions',
    addDriverRestriction:
      environment.apiUrl + '/provider/partners/restrictions',
    getDriverEquipment: environment.apiUrl + '/provider/partners',
    updateDriverEquipment: environment.apiUrl + '/provider/partners',
    getAdroitEquipment: environment.apiUrl + '/provider/partners',
    updateAdroitEquipment: environment.apiUrl + '/provider/partners',
    deleteEmergencyContact: environment.apiUrl + '/provider/Contacts',
    getAllPartners: environment.apiUrl + '/provider/partners/get',
    getStudent: environment.apiUrl + '/provider/rides/finder/passengers',
    deleteVehicle: environment.apiUrl + '/provider/partners',
    updateVehicleUsed: environment.apiUrl + '/provider/partners',
    updateContractor: environment.apiUrl + '/provider/partners',
    notifyCompliance: environment.apiUrl + '/provider/partners',
  },

  accounting: {
    myPayouts: environment.apiUrl + '/provider/payouts/group-year',
    myPayoutsSub: environment.apiUrl + '/provider/payouts/Sub-year',
    driversWeeklyPayouts:
      environment.apiUrl + '/provider/payouts/partners-report',
    driversPayoutStatements:
      environment.apiUrl + '/provider/payouts/group-partners-statements',
    driversPayoutStatistics:
      environment.apiUrl + '/provider/payouts/driver-weekly-payout-statistics',
    payoutDispute: environment.apiUrl + '/provider/payouts/dispute',
    generateExcelMyPayouts:
      environment.apiUrl + '/provider/payouts/report-year-excel',
    generateExcelDriversWeeklyPayouts:
      environment.apiUrl + '/provider/payouts/partners-report-excel',
    generateCsvDriversWeeklyPayouts:
      environment.apiUrl + '/provider/payouts/partners-report-csv',
    checkPartnersReportCsv:
      environment.apiUrl + '/provider/payouts/check-partners-report-csv',
    PartnersPDFfiLe: environment.apiUrl + '/provider/payouts/statements-PDF',
    PartnersPDFfiLeBase64: environment.apiUrl + '/provider/file/download-file',
    generateExcelDriversPayoutStatements:
      environment.apiUrl + '/provider/payouts/statements-report-excel',
    periodFilters: environment.apiUrl + '/provider/payouts/periods-years',
    PartnersForAccounting: environment.apiUrl + '/provider/payouts/partners',
    addPayoutDispute: environment.apiUrl + '/provider/payouts/dispute-provider',
    percentage: environment.apiUrl + '/provider/payouts/suggested-percentage',
    activityReport: environment.apiUrl + '/provider/payouts/activity-report',
    driversSubPayoutStatements:
      environment.apiUrl + '/provider/payouts/sub-partners-statements',
  },

  routing: {
    blueprintManagement: environment.apiUrl + '/provider/blueprints/get',
    getBlueprintIds: environment.apiUrl + '/provider/blueprints/filter',
    blueprintOffers: environment.apiUrl + '/provider/blueprints/offers',
    sheet: environment.apiUrl + '/provider/blueprints/data-sheet',
    getBlueprintClients: environment.apiUrl + '/provider/blueprints/clients',
    getBlueprintOfferClients:
      environment.apiUrl + '/provider/blueprints/offers/clients',
  },

  rides: {
    activeRides: environment.apiUrl + '/provider/rides/get',
    rideSimulator: environment.apiUrl + '/provider/rides/simulator',
    activityLog: environment.apiUrl + '/provider/rides',
    ridesStudents: environment.apiUrl + '/provider/rides',
    ridesPlaces: environment.apiUrl + '/provider/rides',
    contractors:
      environment.apiUrl + '/provider/rides/arrival-time-report/drivers',
    wayPoints: environment.apiUrl + '/provider/rides',
    ridesSummary: environment.apiUrl + '/provider/rides',
    bluePrints: environment.apiUrl + '/provider/blueprints/drivers',
    assignedDrivers:
      environment.apiUrl + '/provider/blueprints/assigned-drivers',
    assignedDriversPercent: environment.apiUrl + '/provider/payouts/blueprints',
    rideAdjustment: environment.apiUrl + '/provider/rides/payout-percentage',
  },

  shared: {
    filters: {
      serviceAreas: environment.apiUrl + '/provider/organization/service-areas',
      states: environment.apiUrl + '/provider/rides/serviceProvider/states',
      PayoutsPeriodsLastYear:
        environment.apiUrl + '/provider/payouts/periods-last-year',
      driversNames: environment.apiUrl + '/provider/partners/get',
      subDrivers: environment.apiUrl + '/provider/blueprints/drivers',
      bluePrintSubDriver: environment.apiUrl + '/provider/payouts/blueprints',
      bluePrintSubDriverUpdate: environment.apiUrl + '/provider/rides',
      places: environment.apiUrl + '/provider/places/get',
      providerPartners:
        environment.apiUrl + '/provider/partners/provider-partners',
    },
    account: {
      changePassword: environment.apiUrl + '/provider/accounts/change-password',
      logOut: environment.apiUrl + '/provider/accounts/logout',
      refreshToken:
        environment.apiUrl + '/provider/authentication/refresh-token',
    },
    files: {
      uploadFile: environment.apiUrl + '/provider/file/upload-file',
      deleteFile: environment.apiUrl + '/provider/file/delete',
      downloadFile: environment.apiUrl + '/provider/file/download-file',
    },
  },

  configurations: {
    GetByName: environment.apiUrl + '/provider/configurations',
  },

  dashboards: {
    GetByCode: environment.apiUrl + '/provider/reports/get',
  },

  timeZone: {
    GetTimezone: environment.apiUrl + '/provider/organization/server-timezone',
    timeZone: environment.apiUrl + '/provider/organization/google/timezone',
  },

  vehiclesAndEquipment: {
    GetVehiclesGrid: environment.apiUrl + '/provider/vehicles',
    GetYearsFilter: environment.apiUrl + '/provider/vehicles/year',
    GetEquipments: environment.apiUrl + '/provider/Equipments/equipments',
    AddEquipment: environment.apiUrl + '/provider/Equipments/equipments',
    GetEquipmentsTypes:
      environment.apiUrl + '/provider/Equipments/organization-equipments',
    GetAssignmentsEquipments:
      environment.apiUrl + '/provider/Equipments/assignments-equipments',
    GetApprovedEquipments: environment.apiUrl + '/provider/Equipments',
    AssignEquipment: environment.apiUrl + '/provider/Equipments/partners',
  },
  about: {
    getVersionSettings: environment.apiUrl + '/provider/About/propertyName',
  },
};
